import { scrollToElement } from './scrollToElement';

export const DATA_SCROLL_FORM_ERROR_ID_ATTR = 'data-form-kit-scroll-form-error-id';

/**
 * Пропсы для скролла к блоку ошибок формы
 */
export type ScrollFormErrorProps = {
    /** data атрибут */
    [DATA_SCROLL_FORM_ERROR_ID_ATTR]: string;
};

/**
 * Возвращает id блока ошибок формы, позволяющий прокрутить страницу до него
 */
export function getScrollFormErrorId({ formName, formId }: { formName: string; formId: string }) {
    return `${formName}-${formId}-form-error`;
}

/**
 * Возвращает пропсы, позволяющие прокрутить страницу до блока ошибок формы
 */
export function getScrollFormErrorProps({
    formName,
    formId,
}: {
    formName: string;
    formId: string;
}): ScrollFormErrorProps {
    return {
        [DATA_SCROLL_FORM_ERROR_ID_ATTR]: getScrollFormErrorId({ formName, formId }),
    };
}

/**
 * Прокручивает страницу до блока ошибок формы, возвращает true, если блок найден, иначе false
 */
export function scrollToFormError({ formName, formId }: { formName: string; formId: string }) {
    const scrollFormErrorId = getScrollFormErrorId({ formName, formId });
    const escapedScrollFormErrorId = CSS.escape(scrollFormErrorId);
    const element = document.querySelector(`[${DATA_SCROLL_FORM_ERROR_ID_ATTR}="${escapedScrollFormErrorId}"]`);

    if (element) {
        scrollToElement(element);
        return true;
    }

    return false;
}
